module.exports = __webpack_public_path__ + "img/wells-uncorrelated.b13a780e.svg";